export class ListSaasEntitiesRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SaasEntityTypeFilters",
            "format": ""
        },
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
